import axios from "axios";

interface ReverseGeocodeResponse {
  features: any[];
}

async function reverseGeocode(
  longitude: number,
  latitude: number,
  accessToken: string,
): Promise<ReverseGeocodeResponse> {
  const url = "https://api.mapbox.com/search/geocode/v6/reverse";

  const params = {
    longitude,
    latitude,
    access_token: accessToken,
    permanent: true,
    limit: 1,
  };

  const response = await axios.get<ReverseGeocodeResponse>(url, { params });
  return response.data;
}

export async function getRegionForCoordinates(
  longitude: number,
  latitude: number,
) {
  const token = import.meta.env.REACT_APP_MAPBOX_PUBLIC_KEY ?? "ERROR";
  const response = await reverseGeocode(longitude, latitude, token);
  if (response.features.length === 0) {
    return undefined; // or null?
  }
  if (response.features[0].properties?.context?.region?.region_code_full) {
    return response.features[0].properties.context.region.region_code_full;
  }
  // no region found
  return undefined;
}
